import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Spin, Input, Form, Select, TreeSelect } from 'antd';
import _ from 'lodash';
import PageTitle from 'shared_components/page_title';
import Restriction from 'modules/main/lab_request/steps/lr_restriction/restriction';
import Tracker from 'modules/main/lab_request/tracker';
import {
	LR_SEL_EXAMS,
	LR_SEL_CONTENTS,
	LR_SEL_PANEL_CONTENTS,
	LR_OTHER_INFO,
	LR_REQUEST_TYPE,
	LR_IS_EXAM_UPDATED,
	LR_EDIT_SEL_EXAM_REF,
	LR_EDIT_QEXAMS,
} from 'modules/main/lab_request/steps/constants';
import { moduleTitles, requestTypes } from 'modules/main/settings/lab_exam_request/settings';
import { fetchExamsByReqId } from 'services/lab_request/labRequest';
import { fetchExamAndPanelList, fetchSectionExams } from 'services/lab_request/examPanelList';
import { fetchLabResultExamItems, fetchLabResult } from 'services/lab_result/result';
import SectionHeader from './section_header';
import SectionContent from './section_content';
import SelectTable from './table';
// import SelectTableNew from './newTable'
// import SectionHeaderNew from './newSection_header'
// import SectionContentNew from './newSection_content'
import Navigation from './navigation';
import content from 'shared_components/layout/content';
import { cps } from 'redux-saga/effects';
import { fetchRequestSpecimenToProcess } from 'services/phlebo/specimenTracking';
import Item from 'antd/lib/list/Item';

const { Option } = Select;

const ColLayout = {
	sm: { span: 24 },
	md: { span: 24 },
	lg: { span: 12 },
};

const Loading = () => {
	return (
		<div style={{ textAlign: 'center', marginTop: 150, marginBottom: 100 }}>
			<Spin tip="Loading..." />
		</div>
	);
};

class SelectStep extends React.Component {
	state = {
		componentDidMount: false,
		isLoading: false,
		selectedSection: {
			sectionID: null,
			sectionName: null,
			sectionCode: null,
		},
		approvedSpecimen: [],
		selectedSpecimen: {},
		selectedExams: [],
		selectedContents: [], // holds all selected contents including panels and single exam
		selectedContentsByPanel: [], // holds the selected contents of 1 panel only
		cancelledSections: [],
		exams: [], // holds the list of exam to be selected (left side)
		panels: [], // holds the list of panel to be selected (left side)
		sampleData: [],
		panelRef: [], // holds the reconstructed panel object from raw response panel object
		panelRefnew: [],
		value: undefined,
		examPanelList: [],
	};

	constructor(props) {
		super(props);
		// 3 is the stepnumber
		this.restriction = new Restriction(3);
	}

	onChange = value => {
		console.log(value);
		this.setState({ value });
	};

	async componentDidMount() {
		const sessExams = sessionStorage.getItem(LR_SEL_EXAMS);
		const sessContents = sessionStorage.getItem(LR_SEL_CONTENTS);
		const sessPanelContents = sessionStorage.getItem(LR_SEL_PANEL_CONTENTS);

		//ACD new requirement for Drop down
		const getexamPanelList = await fetchExamAndPanelList();

		// console.log('examPanelList =>', getexamPanelList);

		this.setState({
			examPanelList: getexamPanelList,
		});

		if (sessExams) {
			this.setState({
				selectedExams: JSON.parse(sessExams),
				selectedContents: JSON.parse(sessContents),
				selectedContentsByPanel: JSON.parse(sessPanelContents),
			});
		}
	}

	// DATA FOR EDIT REQUEST
	// DATA MANIPULATION FOR EDIT REQUEST
	async componentDidUpdate(prevProps, prevState) {
		const { componentDidMount, panelRef } = this.state;

		// Variables for Edit Module
		const sessOtherInfo = sessionStorage.getItem(LR_OTHER_INFO);
		const sessExamUpdated = sessionStorage.getItem(LR_IS_EXAM_UPDATED);
		const isFreshExams = sessExamUpdated === String(0);
		const requestID = sessOtherInfo ? JSON.parse(sessOtherInfo).requestID : null;
		// Set selected items for Edit Request
		// Note. This will run only:
		// -One time run only
		// -For edit request
		// -When panel ref has value
		// -When session exams is not updated upon the process of editting
		if (!componentDidMount && requestID && panelRef.length !== 0 && isFreshExams) {
			this.setState({ componentDidMount: true });

			const qexams = await fetchExamsByReqId(requestID);
			// const specs = await fetchRequestSpecimenToProcess(requestID);
			let zexams = [];
			let zpanelContents = [];
			let setPanelIDs = new Set();
			let setContents = new Set();
			let approvedSpecs = [];

			console.log(qexams);

			qexams.forEach(tier1 => {
				tier1.contents.forEach(tier2 => {
					const tmpRoot = {};
					const tmpPanel = {};
					const tmpSpecimen = {};
					const tmpSection = {};
					const tmpAppr = {};
					tmpSpecimen.specimenID = tier1.specimenID;
					tmpSpecimen.specimenName = tier1.specimenName;

					tmpSection.sectionID = tier1.sectionID;
					tmpSection.sectionName = tier1.sectionName;
					tmpSection.sectionCode = tier1.sectionCode;

					tmpPanel.panelID = tier2.panelID;
					tmpPanel.panelName = tier2.panelName;
					tmpPanel.panelCode = tier2.panelCode;

					tmpRoot.examID = tier2.examID;
					tmpRoot.examName = tier2.examRequestName;
					tmpRoot.examCode = tier2.examRequestCode;
					tmpRoot.sampleSpecimenID = tier2.sampleSpecimenID;
					tmpRoot.SampleName = tier1.sectionName;
					tmpRoot.selectedPanel = tier2.panelID ? tmpPanel : null;
					tmpRoot.selectedSpecimen = tmpSpecimen;
					tmpRoot.selectedSection = tmpSection;
					tmpRoot.isDisabled = false;
					tmpRoot.isLocked = tier2.statusPerExam !== 'Open';
					tmpRoot.isSectionLocked = tier1.status !== 'Open';

					tmpRoot.examRequestAutoSTAT = tier2.priority;
					tmpRoot.examRequestAutoSTATIsDisable = tier2.priority === 1 ? true : false;
					tmpRoot.examRequestAutoSendOut = tier2.sendOut;
					tmpRoot.examRequestAutoSendOutDisable = tier2.sendOut === 1 ? true : false;

					zexams.push(tmpRoot);
					setPanelIDs.add(tier2.panelID);

					tier2.contents.forEach(item => setContents.add(item));

					//prepare data for approved exams
					tmpAppr.sectionID = tier1.sectionID;
					tmpAppr.specimenID = tier1.specimenID;
					tmpAppr.sampleSpecimenID = tmpRoot.sampleSpecimenID;
					tmpAppr.isSpecimenLocked = tmpRoot.isSectionLocked;
					approvedSpecs.push(tmpAppr);
				});
			});

			console.log(approvedSpecs);

			const selectedPanel = panelRef.filter(item => Array.from(setPanelIDs).includes(item.panelID));

			selectedPanel.forEach(panelRef => {
				panelRef.exams.forEach(exam => {
					zpanelContents = zpanelContents.concat(exam.contents);
				});
			});

			// Store raw exams from API to local storage
			sessionStorage.setItem(LR_EDIT_SEL_EXAM_REF, JSON.stringify(zexams));
			sessionStorage.setItem(LR_EDIT_QEXAMS, JSON.stringify(qexams));

			this.setState({
				sampleData: qexams,
				selectedExams: zexams,
				approvedSpecimen: approvedSpecs,
				// selectedContents: zpanelContents,
				selectedContents: Array.from(setContents),
				selectedContentsByPanel: zpanelContents,
			});
		}
	}

	populateExams = exams => {
		console.log('populateExams initiated =>')

		const { selectedExams, selectedContents } = this.state;

		console.log('populateExams exams =>', exams)
		console.log('populateExams selectedExams =>', selectedExams);
		console.log('populateExams selectedContents =>', selectedContents);

		const processedExams = exams.map(exam => {
			// const isSelected = selectedExams.some(item => exam.examCode === item.examCode);

			// console.log('selected 1 exam =>', exam);
			const isSelected = selectedExams.some(item => exam.examID === item.examID);

			const isDisabled = selectedExams.some(item => {
				// const isInContents = selectedContents.some(selContent =>
				// 	Array.isArray(selContent) && exam.contents.includes(selContent),
				// );

				// if (item.examID === exam.examID && item.selectedPanel !== null) {
				// 	return true;
				// }

				if (item.examID === exam.examID && item.isLocked) {
					return true;
				}

				// if (isInContents && !isSelected) {
				// 	return true;
				// }

				if(_.intersection(selectedContents, exam.contents).length > 0 && !isSelected) {
					return true;
				}

				return false;
			});
			// dito
			const isLocked = selectedExams.some(item => item.examID === exam.examID && item.isLocked);

			return { ...exam, isSelected, isDisabled, isLocked };
		});


		this.setState({ exams: processedExams });
	};

	//ACD dropdown function to handle dropdown select (single exam or panel)
	populateExamsDropdown = async (sectionID, exam) => {
		const { examPanelList, selectedExams, selectedContents, exams } = this.state;
		// sectionID = sectionID
		// requestID = examID
		// panel is selected = if requestID or specimenID === 0

		console.log('rightSide Exams =>', selectedExams);
		console.log('populatedExamsDropdown Exams =>', exams );

		const getRecord = examPanelList.filter(items => items.recordID === sectionID);
		const newSectionID = getRecord[0].sectionID;

		if (getRecord[0].requestID === 0 || getRecord[0].specimenID === 0) {
			const panelID = getRecord[0].requestID;
			this.addSelectedExamByPanel({ panelID });
		} else {
			//weird hindi ginamit pero nag eerror pag tinanggal ACD
			const getexamPanelList = await fetchSectionExams(newSectionID);
			const getlistofExam = getexamPanelList[0].perSpecimen[0].exams;
			console.log('getexamPanelList =>', getexamPanelList);

			//parameters required for exams
			const examID = getRecord[0].requestID;
			const examName = getRecord[0].requestName;
			const examCode = getRecord[0].examCode;
			const contents = getRecord[0].contents;

			console.log('populateExamsDropdown contents =>', contents);

			//parameters required for section
			const sectionIDnew = getRecord[0].sectionID;
			const sectionName = getRecord[0].sectionName;
			const sectionCode = getRecord[0].sectionCode;
			const specimenID = getRecord[0].specimenID;
			const specimenName = getRecord[0].specimenName;

			const selectedSection = {
				sectionID: sectionIDnew,
				sectionName: sectionName,
				sectionCode: sectionCode,
			};

			const selectedSpecimen = {
				specimenID: specimenID,
				specimenName: specimenName,
			};
			
			// console.log('selectedSection =>', selectedSection);
			// console.log('selectedSpecimen =>', selectedSpecimen);
			// console.log('selectedContents =>', contents);
			// console.log('record =>', getRecord[0]);

			const mergedContents = [...new Set([...selectedContents, ...contents])];



			this.setState({
				selectedSection: selectedSection,
				selectedSpecimen: selectedSpecimen,
				selectedContents: mergedContents,
			},
			()=>{
				this.addSelectedExamByExam({ examID, examName, examCode, contents }, 
					()=>{
						
						this.populateExams(getlistofExam);
						// this.populateExams(exams);
					}
				);
			}
		);
			// this.populateExams(getlistofExam);
		}
	};

	populatePanelRef = panels => {
		console.log('populate panel ref =>', panels);
		const panelRef = [];

		panels.forEach(panel => {
			const panelModel = {
				panelCode: panel.panelCode,
				panelID: panel.panelID,
				panelName: panel.panelName,
				exams: [],
			};

			panel.exams.forEach(exam1 => {
				exam1.perSpecimen.forEach(perSpecimen => {
					perSpecimen.exams.forEach(exam2 => {
						panelModel.exams.push({
							examID: exam2.examID,
							examName: exam2.examName,
							examCode: exam2.examCode,
							section: exam1.section,
							specimen: perSpecimen.specimen,
							contents: exam2.contents,
						});
					});
				});
			});

			console.log(panelModel);

			panelRef.push(panelModel);
		});

		// console.log('populatePanelRef panelRef =>', panelRef);
		this.setState({ panelRef }, () => {
			this.populatePanels();
		});
	};

	populatePanelRefNew = panels => {
		const panelRef = [];

		panels.forEach(panel => {
			const panelModel = {
				panelCode: panel.panelCode,
				panelID: panel.panelID,
				panelName: panel.panelName,
				exams: [],
			};

			panel.exams.forEach(panels => {
				const examsName = panels.exams.map(exams => {
					return {
						examName: exams.examName,
						examID: exams.examID,
						examCode: exams.examCode,
					};
				});
				panelModel.exams.push({
					sectionname: panels.section.sectionName,
					specimenName: panels.specimen.specimenName,
					examName: examsName,
				});
			});
			panelRef.push(panelModel);
		});
		this.setState({ panelRefnew: panelRef });
	};

	populatePanelsNew = () => {
		const { panelRefnew, selectedExams } = this.state;
		let lockedPanelIDs = new Set();

		selectedExams.forEach(exam => {
			if (exam.selectedPanel && exam.isLocked) lockedPanelIDs.add(exam.selectedPanel.panelID);
		});

		const panels = panelRefnew.map(ipanelRef => {
			let isDisabled = false;

			// Check selected exams if it is present in the ipanelRef
			// then set selected if its true
			const isSelected = selectedExams.some(selectedExam => {
				const { selectedPanel } = selectedExam;

				return selectedPanel && ipanelRef.panelID === selectedPanel.panelID;
			});

			if (isSelected === false) {
				// Check selected exams if it is present in the ipanelRef's exams
				// then set disabled if its true
				isDisabled = selectedExams.some(selectedExam => {
					return ipanelRef.exams.some(exam => {
						if (selectedExam.examID === exam.examID) return true;

						return false;
					});
				});
			}

			// Checl if current Panel ID is included in the list of locked Panel IDs
			// then disable the panel if it is included
			if (Array.from(lockedPanelIDs).includes(ipanelRef.panelID)) {
				isDisabled = true;
			}

			return {
				panelID: ipanelRef.panelID,
				panelCode: ipanelRef.panelCode,
				panelName: ipanelRef.panelName,
				isDisabled,
				isSelected,
			};
		});

		this.setState({ panels });
	};

	populatePanels = () => {
		// console.log('populate panels called =>');
		// console.log('populatePanels panelRef =>', this.state.panelRef);
		const { panelRef, selectedExams } = this.state;
		let lockedPanelIDs = new Set();

		selectedExams.forEach(exam => {
			if (exam.selectedPanel && exam.isLocked) lockedPanelIDs.add(exam.selectedPanel.panelID);
		});

		const panels = panelRef.map(ipanelRef => {
			let isDisabled = false;

			// Check selected exams if it is present in the ipanelRef
			// then set selected if its true
			const isSelected = selectedExams.some(selectedExam => {
				const { selectedPanel } = selectedExam;

				return selectedPanel && ipanelRef.panelID === selectedPanel.panelID;
			});

			if (isSelected === false) {
				// Check selected exams if it is present in the ipanelRef's exams
				// then set disabled if its true
				isDisabled = selectedExams.some(selectedExam => {
					return ipanelRef.exams.some(exam => {
						if (selectedExam.examID === exam.examID) return true;

						return false;
					});
				});
			}

			// Checl if current Panel ID is included in the list of locked Panel IDs
			// then disable the panel if it is included
			if (Array.from(lockedPanelIDs).includes(ipanelRef.panelID)) {
				isDisabled = true;
			}

			return {
				panelID: ipanelRef.panelID,
				panelCode: ipanelRef.panelCode,
				panelName: ipanelRef.panelName,
				isDisabled,
				isSelected,
			};
		});

		// console.log('populatePanels panels =>', panels);

		this.setState({ panels });
	};

	updateSelectedSection = ({ sectionID, sectionName, sectionCode }) => {
		this.setState({ selectedSection: { sectionID, sectionName, sectionCode } });
	};

	updateSelectedSpecimen = ({ specimenID, specimenName }) => {
		this.setState({ selectedSpecimen: { specimenID, specimenName } });
	};

	// Note. This function is use to update the isSelected state of the exam tag
	updateExam = ({ examID, isSelected }) => {
		const { exams } = this.state;
		const updatedExams = exams.map(item => {
			if (item.examID === examID) return { ...item, isSelected };

			return item;
		});

		this.setState({ exams: updatedExams });
	};

	// Note. This function is use to update the isSelected state of the panel tag
	updatePanel = ({ panelID, isSelected }) => {
		const { panels } = this.state;

		const updatedPanels = panels.map(item => {
			if (item.panelID === panelID) return { ...item, isSelected };

			return item;
		});

		this.setState({ panels: updatedPanels });
	};

	// Note. This function is use to add the selected exam from list
	// the list of exams table (left) into selected exams table (right).
	// Used when selecting panel
	addSelectedExamByPanel = ({ panelID }) => {
		console.log('panelID', panelID);
		const { panelRef, selectedContents } = this.state;
		const selectedPanel = panelRef.find(item => item.panelID === panelID);
		let newSelectedContents = [];

		selectedPanel.exams.forEach(exam => {
			this.addSingleExam({
				examID: exam.examID,
				examName: exam.examName,
				examCode: exam.examCode,
				selectedSection: exam.section,
				selectedSpecimen: exam.specimen,

				examRequestAutoSTAT: exam.examRequestAutoSTAT,
				examRequestAutoSTATIsDisable: exam.examRequestAutoSTAT === 1 ? true : false,
				examRequestAutoSendOut: exam.examRequestAutoSendOut,
				examRequestAutoSendOutDisable: exam.examRequestAutoSendOut === 1 ? true : false,

				selectedPanel: {
					panelID: selectedPanel.panelID,
					panelName: selectedPanel.panelName,
					panelCode: selectedPanel.panelCode,
				},
				// isDisabled: true
			});

			// Append selectedContents into one array
			newSelectedContents = newSelectedContents.concat(exam.contents);
		});
		this.setState({
			selectedContents: newSelectedContents.concat(selectedContents),
			selectedContentsByPanel: newSelectedContents,
		});
	};

	// Note. This function adds any selected exam from 
	// options in the left panel to the right panel.
	addSelectedExamByExam = ({ examID, examName, examCode, contents }, callback) => {
		const { selectedSection, selectedSpecimen, selectedContents } = this.state;
		const isExistingContent = selectedContents.some(iContent => Array.isArray(contents) && contents.includes(iContent));
		const newSelectedContents = selectedContents.map(item => item); // Clone selectedContents

		// console.log('contents =>', contents);
		// console.log('selectedContents =>', selectedContents);

		// Add selectedContent to the array of selectedContent(s)
		if (!isExistingContent) newSelectedContents.push(...contents || []);

		// console.log('newSelectedContents =>', newSelectedContents);

		this.setState(
			{
				selectedContents: newSelectedContents,
			},
			() => {
				// eslint-disable-next-line no-shadow
				const { exams, selectedContents } = this.state;

				// Note. Disable exams that is in the selectedContents
				const newExams = exams.map(exam => {
					const isDisabled = selectedContents.some(item => {
						return Array.isArray(exam.contents) && exam.contents.includes(item) && exam.examID !== examID && !exam.isSelected;
					});
					return {
						...exam,
						// Note. Do not enable if already disabled, This is for SelectByPanel Rule
						isDisabled: exam.isDisabled ? exam.isDisabled : isDisabled,
					};
				});

				this.setState({
					exams: newExams,
				},
				() => {
					if (typeof callback === 'function') {
						callback();
					}
				});
			},
		);

		const { exams } = this.state;
		// Retrieve examRequestAutoSTAT and examRequestAutoSendOut from the exam object

		const examsSnapshot = Array.isArray(exams) ? exams : [];
		const foundExam = examsSnapshot.find(exam => exam.examID === examID);
		
		if(foundExam){
			// const { examRequestAutoSTAT, examRequestAutoSendOut } = exams.find(
			// 	exam => exam.examID === examID,
			// );
			
			const { examRequestAutoSTAT = 0, examRequestAutoSendOut = 0 } = foundExam;

			// Pass the retrieved values to addSingleExam function
			this.addSingleExam({
				examID,
				examName,
				examCode,
				selectedSection,
				selectedSpecimen,
				examRequestAutoSTAT,
				// examRequestAutoSTATIsDisable: examRequestAutoSTAT === 1 ? true : false,
				examRequestAutoSTATIsDisable: examRequestAutoSTAT === 1,
				examRequestAutoSendOut,
				// examRequestAutoSendOutDisable: examRequestAutoSendOut === 1 ? true : false,
				examRequestAutoSendOutDisable: examRequestAutoSendOut === 1,
				contents,
			}, 
			()=>{
				if (typeof callback === 'function') {
					callback();
				}
			}
		);
		// } else{
			// this.addSingleExam({ examID, examName, examCode, selectedSection, selectedSpecimen }, callback);
		}

		// if (typeof callback === 'function') {
			// callback();
		// }
			this.addSingleExam({ examID, examName, examCode, selectedSection, selectedSpecimen, contents }, 
				()=>{
					if (typeof callback === 'function') {
						callback();
					}
				}	
			);
	};

	addSelectedExamByPanelNew = ({ panelID }) => {
		console.log('panelID', panelID);
		const { panelRefnew, selectedContents } = this.state;
		const selectedPanel = panelRefnew.find(item => item.panelID === panelID);
		let newSelectedContents = [];

		selectedPanel.exams.forEach(exam => {
			const ListOfID = exam.examName.map(element => {
				return element.examID;
			});
			this.addSingleExamnew({
				examName: exam.examName,
				// examCode: exam.examCode,
				selectedSection: exam.sectionname,
				selectedSpecimen: exam.specimenName,
				selectedPanel: {
					panelID: selectedPanel.panelID,
					panelName: selectedPanel.panelName,
					panelCode: selectedPanel.panelCode,
				},
				examID: ListOfID,
				isDisabled: true,
			});

			// // Append selectedContents into one array
			newSelectedContents = newSelectedContents.concat(exam.contents);
		});
		this.setState({
			selectedContents: newSelectedContents.concat(selectedContents),
			selectedContentsByPanel: newSelectedContents,
		});
	};

	addSelectedExamByExamNew = ({ examID, examName, examCode, contents }) => {
		const { selectedSection, selectedSpecimen, selectedContents } = this.state;
		const isExistingContent = selectedContents.some(iContent => contents.includes(iContent));
		const newSelectedContents = selectedContents.map(item => item); // Clone selectedContents

		// Add selectedContent to the array of selectedContent(s)
		if (!isExistingContent) newSelectedContents.push(...contents);

		this.setState({ selectedContents: newSelectedContents }, () => {
			// eslint-disable-next-line no-shadow
			const { exams, selectedContents } = this.state;

			// Note. Disable exams that is in the selectedContents
			const newExams = exams.map(exam => {
				const isDisabled = selectedContents.some(item => {
					// return exam.contents.includes(item) && exam.examID !== examID && !exam.isSelected;
					return Array.isArray(exam.contents) && exam.contents.includes(item) && exam.examID !== examID && !exam.isSelected;
				});

				return {
					...exam,
					// Note. Do not enable if already disabled, This is for SelectByPanel Rule
					isDisabled: exam.isDisabled ? exam.isDisabled : isDisabled,
				};
			});

			this.setState({ exams: newExams });
		});

		this.addSingleExamnew({ examID, examName, examCode, selectedSection, selectedSpecimen });
	};

	// Note. This function is use to append single exam to the exam state
	// Private function
	addSingleExam = (exam, callback) => {
		const { examID, selectedPanel = null, contents = [] } = exam;
		// Note. DO NOT MUTATE THE STATE OBJECT!
		// You will have a nightmare if you do.

		console.log('addSingleExam exam =>', exam);
		this.setState(state => {
			const { selectedExams } = state;
			const isExistingExam = selectedExams.some(iExam => iExam.examID === examID);
			const newSelectedExams = JSON.parse(JSON.stringify(selectedExams)); // Clone selectedExams
			
			if (!isExistingExam) newSelectedExams.push({ ...exam, selectedPanel });
				return { selectedExams: newSelectedExams };
		},
			()=>{
				// console.log('addSingleExam selectedExams =>', this.state.selectedExams);
				this.checkSelectedHasStatOne(exam);
				if(typeof callback === 'function'){
					callback();
				}
			}
		);

	};

	addSingleExamnew = exam => {
		const { examID, selectedPanel = null } = exam;

		// Note. DO NOT MUTATE THE STATE OBJECT!
		// You will have a nightmare if you do.
		this.setState(state => {
			const { selectedExams } = state;
			const isExistingExam = selectedExams.some(iExam => iExam.examID === examID);
			const newSelectedExams = JSON.parse(JSON.stringify(selectedExams)); // Clone selectedExams
			if (!isExistingExam) newSelectedExams.push({ ...exam, selectedPanel });

			return { selectedExams: newSelectedExams };
		});

		this.checkSelectedHasStatOne(exam);
	};

	checkSelectedHasStatOne = exam => {
		this.setState(prevState => {
			const { selectedExams } = prevState;
			// Check if any selected exam in the same section has examRequestAutoSTAT = 1
			const newSelectedExams = selectedExams.map(selectedExam => {
				if (selectedExam.selectedSection.sectionID === exam.selectedSection.sectionID) {
					const hasStatOne = selectedExams.some(
						otherExam =>
							otherExam.selectedSection.sectionID === selectedExam.selectedSection.sectionID &&
							otherExam.selectedSpecimen.specimenID === selectedExam.selectedSpecimen.specimenID &&
							otherExam.examRequestAutoSTAT === 1,
					);
					// If any selected exam in the section has examRequestAutoSTAT = 1, set it for all exams in the section
					if (hasStatOne) {
						return { ...selectedExam, examRequestAutoSTAT: 1 };
					}
				}
				return selectedExam;
			});

			return { selectedExams: newSelectedExams };
		});

		this.setState(prevState => {
			const { selectedExams } = prevState;

			// Check if any selected exam in the same section has examRequestAutoSTATIsDisable = 1
			const newSelectedExams = selectedExams.map(selectedExam => {
				if (selectedExam.selectedSection.sectionID === exam.selectedSection.sectionID) {
					const hasStatDisabled = selectedExams.some(
						otherExam =>
							otherExam.selectedSection.sectionID === selectedExam.selectedSection.sectionID &&
							otherExam.selectedSpecimen.specimenID === selectedExam.selectedSpecimen.specimenID &&
							otherExam.examRequestAutoSTATIsDisable === true,
					);
					// If any selected exam in the section has examRequestAutoSTATIsDisable = true, set it for all exams in the section
					if (hasStatDisabled) {
						return {
							...selectedExam,
							examRequestAutoSTATIsDisable: true,
						};
					}
				}
				return selectedExam;
			});

			return { selectedExams: newSelectedExams };
		});
	};

	checkSelectedHasStatOneRemove = () => {
		const { selectedExams, exams } = this.state;

		// Check if any selected exam has examRequestAutoSTAT value of 1
		const status = selectedExams.some(selectedExam => {
			const matchingExam = exams.find(exam => exam.examID === selectedExam.examID);
			return (
				matchingExam &&
				selectedExam.examRequestAutoSTAT === 1 &&
				matchingExam.examRequestAutoSTAT === 1
			);
		});

		// Update condition to check when no matching condition with STAT 1 is found
		if (!status) {
			const newSelectedExams = selectedExams.map(selectedExam => {
				const matchingExam = exams.find(exam => exam.examID === selectedExam.examID);
				// If no matching exam with STAT 1, enable changing the disable status
				if (matchingExam && matchingExam.examRequestAutoSTAT !== 1) {
					return {
						...selectedExam,
						examRequestAutoSTAT: 0,
						examRequestAutoSTATIsDisable: false,
					};
				}
				return selectedExam;
			});

			this.setState({ selectedExams: newSelectedExams });
		}
	};

	onchangeStatChange = (exam, examRequestAutoSTAT) => {
		const { selectedExams } = this.state;

		console.log(selectedExams);

		this.setState(prevState => ({
			selectedExams: prevState.selectedExams.map(selectedExam => {
				if (selectedExam.examID === exam.examID) {
					return { ...selectedExam, examRequestAutoSTAT: examRequestAutoSTAT ? 1 : 0 }; // Update the stat value for the specific exams
				} else if (
					examRequestAutoSTAT &&
					selectedExam.selectedSection.sectionID === exam.selectedSection.sectionID &&
					selectedExam.selectedSpecimen.specimenID === exam.selectedSpecimen.specimenID
				) {
					// If examRequestAutoSTAT is true and the exam belongs to the same section, set examRequestAutoSTAT to 1 for all exams in that section
					return { ...selectedExam, examRequestAutoSTAT: 1 };
				} else if (
					!examRequestAutoSTAT &&
					selectedExam.selectedSection.sectionID === exam.selectedSection.sectionID &&
					selectedExam.selectedSpecimen.specimenID === exam.selectedSpecimen.specimenID
				) {
					// If examRequestAutoSTAT is false and the exam belongs to the same section, set examRequestAutoSTAT to 0 for all exams in that section
					return { ...selectedExam, examRequestAutoSTAT: 0 };
				}
				return selectedExam;
			}),
		}));
	};

	onchangeSendout = (examID, examRequestAutoSendOut) => {
		this.setState(prevState => ({
			selectedExams: prevState.selectedExams.map(selectedExam => {
				if (selectedExam.examID === examID) {
					return { ...selectedExam, examRequestAutoSendOut: examRequestAutoSendOut ? 1 : 0 }; // Update the stat value for the specific exams
				}

				return selectedExam;
			}),
		}));
	};

	clearExams = () => {
		this.setState({ exams: [] });
	};

	clearPanels = () => {
		this.setState({ panels: [] });
	};

	// Note. This function is use for removing many exams
	// from the selected exams table(right).
	// Used when unselecting panel
	removeSelectedExamByPanel = ({ panelID }) => {
		const { selectedExams, selectedContentsByPanel, selectedContents } = this.state;

		const filteredExams = selectedExams.filter(item => {
			if (item.selectedPanel == null) return true;

			return !(item.selectedPanel && item.selectedPanel.panelID === panelID);
		});

		const filteredContents = selectedContents.filter(a => {
			return !selectedContentsByPanel.some(b => a === b);
		});

		this.setState({
			selectedExams: filteredExams,
			selectedContents: filteredContents,
			selectedContentsByPanel: [],
		});
	};

	// Note. This function is use for removing single exam
	// from both tables(left and right).
	// Used when unselecting exam from both tables(left and right).
	removeSelectedExamByExam = ({ examID }) => {
		// console.log('removeSelectedExamByExam examID =>', examID);
		const { exams, selectedExams, selectedSection, selectedContents } = this.state;
		
		// console.log('removeSelectedExambyExam exams =>', exams);
		// console.log('removeSelectedExambyExam selectedExams =>', selectedExams);

		const { sectionCode } = selectedSection;
		const targetExam = exams.find(exam => examID === exam.examID);

		// console.log('removeSelectedExamByExam targetExam =>', targetExam);

		const newState = {
			selectedExams: selectedExams.filter(item => item.examID !== examID),
			selectedContents: selectedContents.filter(item => {
				if (targetExam) {
					return !(Array.isArray(targetExam.contents) && targetExam.contents.includes(item));
				}else{
					const examInSelected = selectedExams.find(exam => exam.examID === examID);

					if(examInSelected){
						return !(Array.isArray(examInSelected.contents) && examInSelected.contents.includes(item));
					}
					// console.log('removeSelectedExamByExam examInSelected =>', examInSelected);
				}

				// if no targetExam or no contents array, keep the item
				return true;
			}),
		};

		this.setState(newState, () => {
			console.log('selectedContents =>', selectedContents);
			if (sectionCode !== 'panel' && sectionCode !== null) this.unselectExams([{ examID }]);
		});
	};

	// DAM - 2022-02-10
	// Note. This function is use for removing Exams by Section and Specimen
	// Used when unselecting exam from both tables(left and right).
	removeSelectedSpecimen = ({ sectionID, specimenID }) => {
		const { exams, selectedExams, selectedContents } = this.state;
		const newSelectedExams = selectedExams.filter(exam => {
			return !(
				exam['selectedSection'].sectionID === sectionID &&
				exam['selectedSpecimen'].specimenID === specimenID
			);
		});

		// const newSelectedContents = newSelectedExams.forEach(exam => {
		// 	return exam.contents;
		// });

		const uniqueContents = _.uniq(_.flatten(newSelectedExams.map(item => item.contents || [])));
		
		console.log('removeSelectedSpecimen exams =>', exams);
		console.log('removeSelectedSpecimen newSelectedExams =>', newSelectedExams);
		// console.log('removeSelectedSpecimen selectedExams =>', selectedExams);


		const newSelectedContent = [];
		if (newSelectedExams.length > 0) {
			newSelectedExams.forEach(selectedExam => {
				const currentExam = exams.find(exam => exam.examID === selectedExam.examID);
				// console.log('removeSelectedSpecimen currentExam =>', currentExam);
				if (currentExam) {
					// console.log('removeSelectedSpecimen currentExam =>', currentExam.contents);
					newSelectedContent.push(...currentExam.contents);
				}else{
					const common = _.intersection(uniqueContents, selectedExam.contents);
					// newSelectedContent.push(...selectedExam.contents);
					newSelectedContent.push(...common);
				}
			});
		}

		const newState = {
			selectedExams: newSelectedExams,
			selectedContents: newSelectedContent,
		};

		console.log('removeSelectedSpecimen newState =>', newState);

		this.setState(newState, () => {
			const deselectedExams = selectedExams.filter(exam => {
				return (
					exam['selectedSection'].sectionID === sectionID &&
					exam['selectedSpecimen'].specimenID === specimenID
				);
			});
			this.unselectExams(deselectedExams);
			console.log('removeSelectedSpecimen selectedContents =>', this.state.selectedContents);
		});
	};

	removeAllExams = () => {
		const { exams } = this.state;

		this.setState(
			{
				selectedExams: [],
				selectedContents: [],
				selectedContentsByPanel: [],
			},
			() => {
				this.unselectExams(exams);
			},
		);
	};

	// Note. This function is use to unselect exam list table(left)
	// when removing exam from selected exam tab	le(right).
	// Private function
	unselectExams = unselectedExams => {
		console.log(unselectedExams, 'unselectedExams');
		this.checkSelectedHasStatOneRemove();
		const { exams, selectedContents, selectedExams, cancelledSections } = this.state;
		console.log(exams);
		const processedExams = exams.map(exam => {
			// Check if current exam is in the unselected exams
			const isExistInUExam = unselectedExams.some(uexam => exam.examID === uexam.examID);
			const isExistInContents = selectedContents.some(selContent => {
				return Array.isArray(exam.contents) && exam.contents.includes(selContent);
			});
			// const isInSelectedPanel = selectedExams.some(selExam => {
			// 	return exam.examID === selExam.examID && selExam.selectedPanel !== null;
			// });
			const isSelectedExam = selectedExams.some(selExam => exam.examID === selExam.examID);
			const isDisabled = (isExistInContents && !isSelectedExam) || exam.isLocked; // ||  isInSelectedPanel

			console.log(isDisabled);

			if (isExistInUExam) return { ...exam, isSelected: false, isDisabled };

			// console.log(...exam);

			return { ...exam, isDisabled };
		});

		this.setState({
			exams: processedExams,
			cancelledSections: [...cancelledSections],
		});
	};

	// DAM - 20220309 - Modified deletion by Panel
	// Note. This function is use for removing many exams
	// from the selected exams table(right).
	// Used when unselecting panel
	removeSelectedExamByPanelV2 = ({ panelID }) => {
		const { panelRef, selectedExams, selectedContentsByPanel, selectedContents } = this.state;
		const selectedPanel = panelRef.find(item => item.panelID === panelID);

		const filteredExams = selectedExams.filter(item => {
			return !selectedPanel['exams'].some(itemRef => {
				return item.examID == itemRef.examID;
			});
		});

		console.log('selectedContents', selectedContents);

		const filteredContents = selectedContents.filter(a => {
			return !selectedContentsByPanel.some(b => a === b);
		});

		console.log('filteredContents', filteredContents);

		this.setState({
			selectedExams: filteredExams,
			selectedContents: filteredContents,
			selectedContentsByPanel: [],
		});
	};

	displayLoading = isLoading => {
		this.setState({ isLoading });
	};

	render() {
		const {
			selectedExams,
			selectedContents,
			selectedContentsByPanel,
			selectedSection,
			cancelledSections,
			exams,
			panels,
			isLoading,
			approvedSpecimen,
			examPanelList,
		} = this.state;
		const { restriction } = this;
		const { requestType } = this.props;
		const moduleTitle =
			sessionStorage.getItem(LR_REQUEST_TYPE) === requestTypes.create
				? moduleTitles.create
				: moduleTitles.edit;
		const disabled =
			/*sessionStorage.getItem(LR_REQUEST_TYPE) === requestTypes.create  && */ selectedExams.length ===
			0;

		const examPanelListOptions = examPanelList.map(data => ({
			key: data.recordID,
			value: data.recordID,
			title: data.examRequestDisplay,
			disabled: exams.some(exam => exam.examID === data.requestID && exam.isDisabled),
			label: data.examRequestDisplay,
		}));

		if (restriction.hasAccess) {
			return (
				<div>
					<PageTitle pageTitle={moduleTitle} />
					<Tracker active={2} requestType={requestType} />
					<div className="space-y-md"></div>
					{isLoading && <Loading />}
					<div style={{ display: isLoading ? 'none' : 'block' }}>
						<Row>
							<Col lg={{ span: 12 }} md={{ span: 24 }} xs={{ span: 24 }}>
								<Form.Item
									name="exam_list"
									label="EXAM"
									rules={[{ required: true, message: 'Required Field' }]}
									style={{ width: '96%', marginBottom: 0 }}
								>
									<Select
										options={examPanelListOptions}
										autoFocus
										onSelect={this.populateExamsDropdown}
										placeholder="EXAM LIST"
										showSearch
										allowClear={true}
										autoClearSearchValue={true}
										filterOption={(input, option) =>
											option.title.toUpperCase().includes(input.toUpperCase())
										}
									/>
								</Form.Item>
							</Col>
						</Row>
						<div className="space-y-sm"></div>
						<Row gutter={48}>
							<Col {...ColLayout}>
								{/* this is where the exam list and panel list will be displayed (left side)*/}
								<SectionHeader
									populateExams={this.populateExams}
									populatePanels={this.populatePanels}
									populatePanelRef={this.populatePanelRef}
									populatePanelRefNew={this.populatePanelRefNew}
									updateSelectedSpecimen={this.updateSelectedSpecimen}
									updateSelectedSection={this.updateSelectedSection}
									clearExams={this.clearExams}
									clearPanels={this.clearPanels}
									displayLoading={this.displayLoading}
									selectedExams={selectedExams}
									approvedSpecimen={approvedSpecimen}
								/>
								<SectionContent
									exams={exams}
									panels={panels}
									// selectedExams={selectedExams}
									selectedSection={selectedSection}
									addSelectedExamByExam={this.addSelectedExamByExam}
									addSelectedExamByPanel={this.addSelectedExamByPanel}
									removeSelectedExamByExam={this.removeSelectedExamByExam}
									removeSelectedExamByPanel={this.removeSelectedExamByPanelV2}
									updateExam={this.updateExam}
									updatePanel={this.updatePanel}
								/>
							</Col>
							<Col {...ColLayout}>
										{/* this is where the selected exams will be displayed (right side) */}
								<SelectTable
									selectedExams={selectedExams}
									exams={exams}
									removeSelectedExamByPanel={this.removeSelectedExamByPanelV2}
									removeSelectedExamByExam={this.removeSelectedExamByExam}
									removeSelectedSpecimen={this.removeSelectedSpecimen}
									removeAllExams={this.removeAllExams}
									populatePanels={this.populatePanels}
									approvedSpecimen={approvedSpecimen}
									onchangeStatChange={this.onchangeStatChange}
									onchangeSendout={this.onchangeSendout}
								/>
							</Col>
						</Row>
					</div>
					<Navigation
						selectedExams={selectedExams}
						selectedContents={selectedContents}
						selectedPanelContents={selectedContentsByPanel}
						disabled={disabled}
						cancelledPanels={cancelledSections}
					/>
				</div>
			);
		}

		return restriction.redirect();
	}
}

SelectStep.propTypes = {
	requestType: PropTypes.string,
};

SelectStep.defaultProps = {
	requestType: '',
};

export default SelectStep;
